export default __webpack_public_path__ + "static/media/cincin.71478cd1.png";